/**
 * Simple ResizeObserver Loop Fix
 */

import { ref, onMounted } from "vue";

/**
 * Vue composable for stable ElAutoResizer usage
 */
export function useStableAutoResizer() {
  const autoResizerRef = ref<any>(null);

  onMounted(() => {
    // Small delay to let the component stabilize after initial render
    setTimeout(() => {
      if (autoResizerRef.value?.$el) {
        // Force a single layout recalculation to prevent initial instability
        const el = autoResizerRef.value.$el;
        const originalDisplay = el.style.display;
        el.style.display = "none";
        el.offsetHeight; // eslint-disable-line @typescript-eslint/no-unused-expressions -- Trigger reflow
        el.style.display = originalDisplay;
      }
    }, 50);
  });

  return { autoResizerRef };
}
